import { STATUS_STYLE } from "@/lib/nations";
import Flag from "@/components/Flag";
import { NATION_META } from "@/lib/nations";

export function ScoreGauge({ score, size = 128 }) {
  const r = (size - 16) / 2;
  const c = 2 * Math.PI * r;
  const color = score >= 80 ? "#059669" : score >= 50 ? "#D97706" : "#DC2626";
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid="score-gauge">
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth="12" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="12"
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * score) / 100}
          style={{ transition: "stroke-dashoffset 0.8s cubic-bezier(0.22,1,0.36,1)" }} />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <div className="text-center">
          <div className="text-3xl font-heading font-extrabold text-navy">{score}</div>
          <div className="text-[10px] uppercase tracking-wider text-muted-foreground">Score</div>
        </div>
      </div>
    </div>
  );
}

export function StatusBadge({ status, label }) {
  const s = STATUS_STYLE[status] || STATUS_STYLE.red;
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${s.bg} ${s.border} ${s.text}`}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} />
      {label || s.label}
    </span>
  );
}

export function NationBadge({ nation }) {
  const m = NATION_META[nation];
  if (!m) return null;
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-xs font-semibold ${m.badge}`}>
      <Flag nation={nation} className="h-3 w-[18px]" /> {nation}
    </span>
  );
}
